<template>
	<div v-parallax-fit="parallax" class="slide-polaroid">
		<img src="/themes/rise-theme/dist/images/estate/character-view/henry/03_family02.png">
	</div>
</template>

<script>
	export default {
		data() {
			return {
				parallax: [
					{
						start: 1200,
						end: 1600,
						fromStyle: { transform: 'translateY(0%) translateX(0%) rotate(0deg)', opacity: 0 },
           				toStyle: { transform: 'translateY(-100%) translateX(0%) rotate(0deg)', opacity: 1 },
						easing: 'linear'
					},
					{
						start: 4100,
						end: 5100,
						fromStyle: { transform: 'translateY(-100%) translateX(0%) rotate(0deg)', opacity: 1 },
           				toStyle: { transform: 'translateY(-150%) translateX(-1000%) rotate(25deg)', opacity: 1 },
						easing: 'linear'
					}
				]
			}
		}
	}
</script>

<style lang="scss" scoped>
	.slide-polaroid {
		max-width: 190px;
		position: absolute;
		left: 14.5%;
		top: 100%;
		z-index: 1;
		transition: all 0.1s linear;
	}

	@media screen and (max-width: 1680px) {
		.slide-polaroid {
			max-width: 160px;
			left: 15%;
			top: 110%;
		}
	}

	@media screen and (max-width: 1280px) {
		.slide-polaroid {
			max-width: 85px;
			left: 17%;
			top: 107%;
		}
	}

	@media screen and (max-width: 650px) {
		.slide-polaroid {
			max-width: 50px;
			left: 19%;
		}
	}
</style>
